import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  users: any[] = [];
  displayedUsers: any[] = [];
  itemsPerPage: number = 15;
  currentPage: number = 1;
  totalItems: number;
  sortDirection: string = 'asc';
  searchText: string = '';
  mathLib: any = Math;
  fromDate: string = ''; // Add these lines
  toDate: string = '';   // Add these lines
  refNo: string = ''; 
  customerList: string[];  // Add this line
  selectedCustomer: string = '';  // Add this line

  ngOnInit() {
    this.fetchUserData();
    this.totalItems = this.users.length;
    this.updateDisplayedUsers();
    this.initializeCustomerList();
  }
  initializeCustomerList() {
    // Fetch the list of unique customers from your data
    this.customerList = Array.from(new Set(this.users.map(user => user.Customer_Name)));
}

  fetchUserData() {
    // Replace this with your actual user data fetching logic
    // Example data for illustration purposes
    this.users = [
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'LXM0440',orderDate: '01/01/2022', ticketNo: '2401002',status: 'JobTicket',Customer_Name: 'Nutrifood Ghana Limited/Olam',
      Job_Name: 'LXM0426 Nutrisnax Digestifs French Edition 84g',Job_Type: 'REVERSE',Qty_Kgs: '1,000.00',Qty_Pcs: '0.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401031',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2024', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2024', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SBO0118', orderDate: '01/01/2022', ticketNo: '2401040',status: 'Confirmed Orders',Customer_Name: 'DALLY FOOD LIMITED',
      Job_Name: 'SBO0118 (306 X 30 MIC) Plain Bopp',Job_Type: 'Roll Form',Qty_Kgs: '300.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2023', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/10/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate:'01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'LXM0440', orderDate: '01/01/2022', ticketNo: '2401002',status: 'JobTicket',Customer_Name: 'Nutrifood Ghana Limited/Olam',
      Job_Name: 'LXM0426 Nutrisnax Digestifs French Edition 84g',Job_Type: 'REVERSE',Qty_Kgs: '1,000.00',Qty_Pcs: '0.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/11/2023', ticketNo: '2401031',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '10/12/2023', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/20/2024', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SLK0169', orderDate: '01/01/2022', ticketNo: '2401030',status: 'Unconfirmed Orders',Customer_Name: 'COCOA PROCESSING COMPANY LTD',
      Job_Name: 'SLK0169 ALL TIME 1 KG',Job_Type: 'Roll Form',Qty_Kgs: '600.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
      { refNo: 'SBO0118', orderDate: '01/01/2022', ticketNo: '2401040',status: 'Confirmed Orders',Customer_Name: 'DALLY FOOD LIMITED',
      Job_Name: 'SBO0118 (306 X 30 MIC) Plain Bopp',Job_Type: 'Roll Form',Qty_Kgs: '300.00',Qty_Pcs: '52,000.00',Total_Disp: '0.00' },
     
      
    ];
  }

  sortColumn(column: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.users.sort((a, b) => {
      const valueA = a[column].toLowerCase();
      const valueB = b[column].toLowerCase();
      return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
    this.updateDisplayedUsers();
  }

  updateDisplayedUsers() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.displayedUsers = this.filterUsers(this.users).slice(startIndex, endIndex);
  }
  getPages(): number[] {
    const totalPages = this.mathLib.ceil(this.totalItems / this.itemsPerPage);
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  onPageChange(page: number) {
    if (page >= 1 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
      this.currentPage = page;
      this.updateDisplayedUsers();
    }
  }

  // onSearch() {
  //   this.currentPage = 1;
  //   this.updateDisplayedUsers();
  // }
  filterUsers(users: any[]): any[] {
    return users.filter(user =>
        // user.Customer_Name.toLowerCase().includes(this.searchText.toLowerCase()) &&
        this.isDateInRange(user.orderDate, this.fromDate, this.toDate) &&
        user.refNo.toLowerCase().includes(this.refNo.toLowerCase()) &&
        (this.selectedCustomer === '' || user.Customer_Name === this.selectedCustomer)
    );
}
  
  isDateInRange(checkDate: string, fromDate: string, toDate: string): boolean {
    if (!fromDate && !toDate) {
      return true; // No date range specified, so all dates are in range
    }
  
    const date = this.convertToDate(checkDate);
    const from = fromDate ? this.convertToDate(fromDate) : null;
    const to = toDate ? this.convertToDate(toDate) : null;
  
    return (!from || date >= from) && (!to || date <= to);
  } 
  
  convertToDate(dateString: string): Date {
    const parts = dateString.split('/');
    return new Date(`${parts[2]}-${parts[0]}-${parts[1]}`);
  }
  onFilter() {
    this.currentPage = 1;
    this.updateDisplayedUsers();
  }
  onCustomerSelectionChange(): void {
    this.onFilter();
}

onRefNoChange(): void {
    this.onFilter();
}

onDateRangeChange(): void {
    this.onFilter();
}
getNumber(value: any): number {
  if (!value) return 0;
  const num = parseFloat(value.toString().replace(/[^\d.-]/g, ''));
  return isNaN(num) ? 0 : num;
}
  
}
